import React from 'react';
import Navbar from './Navbar';
import { Button, Grid2, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from '@mui/material';
import { Cancel, CheckCircle} from '@mui/icons-material';
import toast from 'react-hot-toast';

export default function SpamList() {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [fetchSpamData, setFetchSpamData] = React.useState([]);

  // Fetch the Spam list data
  const fetchSpamLists = () => {
    const token = localStorage.getItem('accessToken');
    fetch(`https://api.adoop.in/api/v2/shop_promotion/promotion_status/SPAM`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data.data);
        setFetchSpamData(data.data);  // Update the state with the fetched data
      })
      .catch((error) => console.error(error));
  };

  const fetchLists = () => {
    const token = localStorage.getItem('accessToken');
    fetch(`https://api.adoop.in/api/v2/shop_promotion/promotion_status/ALL`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data.data);
        setFetchSpamData(data.data);  // Update the state with the fetched data
      })
      .catch((error) => console.error(error));
  };

  // Call the function to fetch data on component mount
  React.useEffect(() => {
    fetchSpamLists();
    fetchLists();
  }, []);

  // Handle page change
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0); // Reset page to the first page when rows per page changes
  };

  // Slice the data for the current page
  const currentData = fetchSpamData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  function updateAccept(id, shopId){
    console.log(shopId);
    
    const token = localStorage.getItem('accessToken');
      fetch(`https://api.adoop.in/api/v2/shop_promotion/${shopId}/promotion_status/${id}/ACCEPTED`, {
          method: "PUT",
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            "promotionStatus":"ACCEPTED"
        }) 
        })
        .then(response => response.json())
        .then(data => {
          console.log('Response from server:', data);
          toast.success(data.message)
      
          toast.success("Catalog Updated Successfully");
          // fetchCatalogsLists();
         
        })
        .catch(error => console.error(error));
  }


  function updateDecline(id, shopId){
    console.log(shopId);
    
    const token = localStorage.getItem('accessToken');
      fetch(`https://api.adoop.in/api/v2/shop_promotion/${shopId}/promotion_status/${id}/ACCEPTED`, {
          method: "PUT",
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            "promotionStatus":"DECLINED"
        }) 
        })
        .then(response => response.json())
        .then(data => {
          console.log('Response from server:', data);
          toast.success(data.message)
      
          toast.success("Catalog Updated Successfully");
          // fetchCatalogsLists();
         
        })
        .catch(error => console.error(error));
  }

  return (
    <div>
      <Navbar />
      <br />
      <Typography variant="h4" gutterBottom>
        Spam List
      </Typography>
      <br />
      <Grid2 container>
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
          <TableContainer sx={{ maxHeight: 940 }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell>Sr. No.</TableCell>
                  <TableCell>Shopkeeper Name</TableCell>
                  <TableCell>Address</TableCell>
                  <TableCell>StateName</TableCell>
                  <TableCell>CityName</TableCell>
                  <TableCell>Promotion Name</TableCell>
                  <TableCell>Promotion Description</TableCell>
                  <TableCell>Promotion Custom_text</TableCell>
                  <TableCell>Promotion Status</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {currentData.map((data, index) => (
                  <TableRow key={index}>
                    <TableCell>{page * rowsPerPage + index + 1}</TableCell> {/* Adjust index based on the page */}
                    <TableCell>{data.shop.name}</TableCell>
                    <TableCell>{data.shop.address}</TableCell> {/* Assuming 'address' field exists */}
                    <TableCell>{data.shop.stateName}</TableCell>
                    <TableCell>{data.shop.cityName}</TableCell>
                    <TableCell>{data.name}</TableCell>
                    <TableCell>{data.promotion_attributes.description}</TableCell>
                    <TableCell>{data.promotion_attributes.custom_text}</TableCell>
                    <TableCell>{data.promotionStatus}</TableCell>
                    <TableCell>
                        <Button style={{color:"green"}} onClick={()=>updateAccept(data.id,data.shop.id)}><CheckCircle/></Button>
                        <Button color='error' onClick={()=>updateDecline(data.id,data.shop.id)}><Cancel/></Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={fetchSpamData.length}  
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </Grid2>
    </div>
  );
}
